import { Tooltip } from "react-tooltip";

import { AudiosOnDemand } from "@src/components/Audios/OnDemand";
import { ScheduledAudios } from "@src/components/Audios/Scheduled";
import { Autoplays } from "@src/components/Autoplays";
import { ContactForm } from "@src/components/ContactForm";
import { CurrentTrack } from "@src/components/CurrentTrack";
import { DeferRender } from "@src/components/DeferRender";
import { ErrorMessage } from "@src/components/ErrorMessage";
import { InstallPwa } from "@src/components/InstallPwa";
import { Notification } from "@src/components/Notification";
import { RequestTrack } from "@src/components/RequestTrack";
import { TTS } from "@src/components/TTS";
import { VolumeControl } from "@src/components/VolumeControl";

import { isMobile } from "@src/utils/isMobile";

import "./style.less";
import type { FooterProps } from "./types";

export function Footer({ radio, raspberry = false }: FooterProps) {
  const showTts = radio.tts !== 0;

  return (
    <footer className="Footer-component">
      <ErrorMessage />
      <Tooltip
        id="footer"
        disableTooltip={() => isMobile}
        style={{ zIndex: 4, whiteSpace: "pre-line" }}
      />
      <CurrentTrack />
      <div className="buttons">
        <InstallPwa />
        {!raspberry && (
          <>
            {showTts && <TTS radio={radio} />}
            <DeferRender seconds={1}>
              <Notification radio={radio} />
            </DeferRender>
            <ContactForm mode="modal" />
            {radio.ask_song ? <RequestTrack radio={radio} /> : <></>}
            <AudiosOnDemand radio={radio} />
          </>
        )}
        <ScheduledAudios radio={radio} />
        <Autoplays radio={radio} />
        <VolumeControl />
      </div>
    </footer>
  );
}
